/* RESPONSIBLE TEAM: team-standalone */
import Model, { attr } from '@ember-data/model';

export default class Integration extends Model {
  @attr('string') integrationType!: string;
  @attr('string') displayName!: string;
  @attr('string') externalIdentifier!: string;
  @attr('boolean') supportsHandover!: boolean;
  @attr('boolean') supportsExternalTicketHandover!: boolean;
  @attr('boolean') supportsExternalAgentHandover!: boolean;
}
